import { Box } from '@mui/material'

import React from 'react'

/**
 * Drop-in for `react-block-ui`.
 * Keeps the library's DOM/class names so existing `assets/widgets/react-block-ui` styles apply.
 */
export default function BlockUi({
  tag: Tag = 'div',
  blocking = false,
  children,
  loader,
  message,
  className = '',
  style,
  keepInView: _keepInView,
  renderChildren = true,
  ...rest
}) {
  const rootClassName = ['block-ui', className].filter(Boolean).join(' ')

  return (
    <Tag
      {...rest}
      style={style}
      className={rootClassName}
      aria-busy={blocking || undefined}
    >
      {renderChildren || !blocking ? children : null}
      {blocking ? (
        <Box
          className="block-ui-container"
          tabIndex={0}
          sx={{
            position: "absolute",
            zIndex: "1010",
            top: "0",
            right: "0",
            bottom: "0",
            left: "0",
            height: "100%",
            minHeight: "2em",
            cursor: "wait",
            overflow: "hidden",
          }}
        >
          <Box
            className="block-ui-overlay"
            sx={{
              width: "100%",
              height: "100%",
              background: "rgba(255, 255, 255, 0.8)",
              "html[data-color-mode=\"dark\"] &": {
                background: "rgba(18, 18, 18, 0.82)",
              },
            }}
          />
          <Box
            className="block-ui-message-container"
            sx={{
              position: "absolute",
              top: "50%",
              left: "0",
              right: "0",
              textAlign: "center",
              transform: "translateY(-50%)",
              zIndex: "10001",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Box
              className="block-ui-message"
              sx={{
                color: "#3b3e66",
                background: "none",
                zIndex: "1011",
                "html[data-color-mode=\"dark\"] &": {
                  color: "rgba(255, 255, 255, 0.87)",
                },
              }}
            >
              {loader}
              {message}
            </Box>
          </Box>
        </Box>
      ) : null}
    </Tag>
  )
}
